import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "other-detail-container" }
const _hoisted_2 = {
  key: 0,
  class: "table-container"
}
const _hoisted_3 = { class: "product-info" }

import MarketTypeTab from '@/components/holdings/MarketTypeTab.vue'
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { formatThousandsKeepDecimal } from '@/utils/num_format'
import useHolding from '@/hooks/holdings/useHolding'
import TableEmpty from '@/components/holdings/TableEmpty.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OtherDetail',
  setup(__props) {

const store = useStore()

const assetsInfo = computed(() => {
  const mv = store.state.holdings.extraPosPageList?.totalMv?.find(item => item.ccy === store.state.holdings.currencyActive.value)
  const value = mv ? formatThousandsKeepDecimal(mv.value, 2) : '--'
  return [
    {
      label: '持仓净值(港元)',
      value
    }
  ]
})

const { queryHoldingData, loading } = useHolding({ exchangeType: store.state.holdings.accountTypeActive.value })

const otherList = computed(() => {
  return store.state.holdings.extraPosPageList?.rows || []
})

const formatMarketValue = (marketValueDisplay: string) => {
  const amount = marketValueDisplay?.replace(/,/g, '') || '0'
  return formatThousandsKeepDecimal(amount, 2)
}

onMounted(() => {
  queryHoldingData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MarketTypeTab, { assetsInfo: assetsInfo.value }, null, 8, ["assetsInfo"]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "持仓", -1)),
    (_unref(loading) || otherList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: otherList.value,
            "show-overflow-tooltip": "",
            "header-cell-class-name": "other-detail-table-header-cell",
            "row-class-name": "other-detail-table-row",
            style: {"width":"100%"},
            "max-height": "300"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "名称/ISIN",
                fixed: ""
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(scope.row.stockName) + " / " + _toDisplayString(scope.row.stockCode), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "市值",
                width: "346"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatMarketValue(scope.row.marketValueHkdDisplay)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _unref(loading)]
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "tips" }, " 注：如阁下需交易，请致电+852 2153 3366，与我们联络。 ", -1))
        ]))
      : _createCommentVNode("", true),
    (!_unref(loading) && !otherList.value.length)
      ? (_openBlock(), _createBlock(TableEmpty, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})